import { render, staticRenderFns } from "./SectionEditor.vue?vue&type=template&id=b61b45ce&scoped=true"
import script from "./SectionEditor.vue?vue&type=script&lang=js"
export * from "./SectionEditor.vue?vue&type=script&lang=js"
import style0 from "./SectionEditor.vue?vue&type=style&index=0&id=b61b45ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61b45ce",
  null
  
)

export default component.exports